import React, {useContext} from 'react';
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxContext = React.createContext(null);

export default LetterboxContext;

export const useLetterboxContext = () =>  useContext(LetterboxContext) ;